import { Button, Checkbox, Col, Divider, Flex, Form, Input, Row } from "antd";
import React, { useEffect } from "react";
import LOGO from "../../../assets/images/logo.svg";
import {
  AppleIcon,
  GoogleIcon,
  MicrosoftIcon,
  PassKeyIcon,
} from "../../../components/Icons";
import { useNavigate } from "react-router-dom";

const Signup = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleFinish = () => {
    localStorage.setItem("token", "hello-world");
    navigate("/");
  };

  return (
    <div className="auth-container">
      <div className="main-row">
        <div className="img-col">
          <img
            src={require("../../../assets/images/auth-side-img.jpg")}
            alt=""
          />
        </div>
        <div className="content-col">
          <Flex vertical justify="center" className="content-parent">
            <img src={LOGO} className="logo" alt="logo" />
            <h1 className="heading">Create your account</h1>
            <h3 className="sub-heading">
              Start your journey to seamless compliance.
            </h3>
            <Form
              form={form}
              layout="vertical"
              className="form"
              onFinish={handleFinish}
              initialValues={{
                email: "example@example.com",
              }}
            >
              <Form.Item label="Email Address" name="email">
                <Input type="email" placeholder="Enter your email address" />
              </Form.Item>
              <Form.Item name="agree" valuePropName="checked" label={null}>
                <Checkbox>
                  I agree to all the{" "}
                  <Button type="link">Terms of Service</Button> and{" "}
                  <Button type="link">Privacy Policy</Button>
                </Checkbox>
              </Form.Item>
              <Form.Item label={null}>
                <Button type="primary" htmlType="submit" className="submit-btn">
                  Create Account
                </Button>
              </Form.Item>
            </Form>
            <Divider>or</Divider>
            <Button className="social-login-btn" variant="outlined">
              <GoogleIcon />
              Continue with Google
            </Button>
            <Button className="social-login-btn" variant="outlined">
              <AppleIcon />
              Continue with Apple
            </Button>
            <Button className="social-login-btn" variant="outlined">
              <MicrosoftIcon />
              Continue with Microsoft
            </Button>
            <Button className="social-login-btn" variant="outlined">
              <PassKeyIcon />
              Login with passkey
            </Button>

            <p className="already-account-text">
              Already have an account?{" "}
              <Button
                htmlType="submit"
                type="link"
                onClick={() => navigate("/login")}
              >
                Login
              </Button>
            </p>
          </Flex>
        </div>
      </div>
    </div>
  );
};

export default Signup;
